import { AttributeValue } from "./AttributeValue";
import { AttributeView } from "./AttributeView";
import { CarType, ODDataType } from "@/geoMap/layerFactory/IODLayerName";
import { ExportValue } from "./ExportValue";
import { Feature } from "ol";
import { FeatureType } from "@/geoMap/define/FeatureType";
import { IAttributeConvert } from "./IAttributeConvert";

/**
 * 出力JSONファイル名（OD量データ表示指定時）
 */
const VALUE_JSON_FILE_NAME_DESIGNATION_ODQUANTITY_DATA =
  "od_tripdst_yyyyMMdd_HHmmss.geojson";

/**
 * 出力JSONファイル名（OD量データ表示未指定時）
 */
const VALUE_JSON_FILE_NAME =
  "od_triporg_yyyyMMdd_HHmmss.geojson";

/**
 * 出力CSVファイル名（OD量データ表示指定時）
 */
const VALUE_CSV_FILE_NAME_DESIGNATION_ODQUANTITY_DATA =
  "od_tripdst_yyyyMMdd_HHmmss.csv";

/**
 * 出力CSVファイル名（OD量データ表示未指定時）
 */
const VALUE_CSV_FILE_NAME =
  "od_triporg_yyyyMMdd_HHmmss.csv";

/**
 * OD市区町村指定出力用属性変換クラス
 */
export class ODRangeNodeAttributeConvert implements IAttributeConvert {
  /**
   * 地物
   */
  feature: Feature;

  /**
   * データ種別
   */
  odDataType: ODDataType;

  /**
   * データ種別
   */
  carType: CarType;

  /**
   * 着ノード表示判定用
   */
  isVisibleArrivalNode = false;

  constructor(
    feature: Feature,
    odDataType: ODDataType,
    carType: CarType,
    isVisibleArrivalNode?: boolean
  ) {
    this.feature = feature;
    this.odDataType = odDataType;
    this.carType = carType;
    this.isVisibleArrivalNode = isVisibleArrivalNode;
  }

  /**
   * 地物タイプ取得
   */
  getFeatureType(): FeatureType {
    return FeatureType.ODRangeNode;
  }

  /**
   * 画面用フォーマット取得
   */
  getViewFormatData(): AttributeView {
    const properties = this.feature.getProperties();

    // 調査年度
    const yearLabel = properties.年度 === "R03" ? "令和3年度" : properties.年度;

    let items: { key: string; value: any; isSimple: boolean }[] = [];
    // 画面項目定義リスト
    if (this.isVisibleArrivalNode) {
      items = [
        {
          key: "車種",
          value: this.carType,
          isSimple: true,
        },
        {
          key: "調査年度",
          value: yearLabel,
          isSimple: true,
        },
        {
          key: "発ゾーン名",
          value: properties.発ゾーン名称 ? properties.発ゾーン名称 : null,
          isSimple: true,
        },
        {
          key: "着ゾーン名",
          value: properties.着ゾーン名称 ? properties.着ゾーン名称 : null,
          isSimple: true,
        },
        {
          key: "OD交通量",
          value: properties.下りトリップ数合計値
            ? properties.下りトリップ数合計値
            : properties.下りトリップ数,
          isSimple: true,
        },
        {
          key: "OD交通量（逆方向）",
          value: properties.上りトリップ数合計値
            ? properties.上りトリップ数合計値
            : properties.上りトリップ数,
          isSimple: true,
        },
      ];
    } else {
      items = [
        {
          key: "車種",
          value: this.carType,
          isSimple: true,
        },
        {
          key: "調査年度",
          value: yearLabel,
          isSimple: true,
        },
        {
          key: "ゾーン名",
          value: properties.ゾーン名称,
          isSimple: true,
        },
        {
          key: "選択ゾーン内々交通量",
          value: properties.内部トリップ数,
          isSimple: true,
        },
        {
          key: "選択ゾーン発交通量計",
          value: properties.上りトリップ数合計値,
          isSimple: true,
        },
        {
          key: "選択ゾーン着交通量計",
          value: properties.下りトリップ数合計値,
          isSimple: true,
        },
      ];
    }
    // 画面項目リストでAttributeValue配列を生成しクラス変数に格納後、return
    const attributeValues: AttributeValue[] = [];
    items.forEach((item) => {
      if (
        (this.isVisibleArrivalNode &&
          (item.key === items[4].key || item.key === items[5].key)) ||
        (!this.isVisibleArrivalNode &&
          (item.key === items[3].key ||
            item.key === items[4].key ||
            item.key === items[5].key))
      ) {
        attributeValues.push(
          new AttributeValue(
            item.key + "（トリップ）",
            item.value ? Number(item.value).toLocaleString() : null,
            item.isSimple
          )
        );
      } else {
        attributeValues.push(
          new AttributeValue(
            item.key,
            item.value ? item.value.toString() : null,
            item.isSimple
          )
        );
      }
    });
    return new AttributeView(attributeValues);
  }

  /**
   * ファイル出力用項目取得
   */
  getExportValue(): ExportValue {
    const feature = this.feature.clone();
    feature.getGeometry().transform("EPSG:3857", "EPSG:4326");
    const attributeValues = this.getViewFormatData().attributeValues;
    let jsonFileName = VALUE_JSON_FILE_NAME;
    let csvFileName = VALUE_CSV_FILE_NAME;

    if (this.isVisibleArrivalNode) {
      jsonFileName = VALUE_JSON_FILE_NAME_DESIGNATION_ODQUANTITY_DATA;
      csvFileName = VALUE_CSV_FILE_NAME_DESIGNATION_ODQUANTITY_DATA;
    }
    return new ExportValue(feature, attributeValues, jsonFileName, csvFileName);
  }
}
